module.exports = __webpack_public_path__ + "img/parameters.f97593f2.svg";